import React from 'react';

import { ProfileContent } from 'src/web/components/Settings/Profile';

const ProfilePage = () => {
  return <ProfileContent />;
};

export default ProfilePage;
